<button class="sg-button-nav sg-rounded d-inline-flex justify-content-center">
    <mlp-ng-icon name="arrow-{{side}}-1"></mlp-ng-icon>
</button>

